import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

const ctasSliders = document.querySelectorAll('.js-card-hover-effect');

if (ctasSliders) {
	ctasSliders.forEach(slider => {
		const cards = slider.querySelectorAll('.card-cta--content');

		if (cards) {
			gsap.registerPlugin(CustomEase);
			let mm = gsap.matchMedia();

			mm.add(
				'(prefers-reduced-motion: no-preference) and (min-width: 992px) and (hover: hover) and (pointer: fine)',
				context => {
					cards.forEach(card => {
						let tl = gsap.timeline({
							paused: true,
						});

						tl.addLabel('start');

						tl.to(
							card.querySelector('.card-cta__link-arrow'),
							{
								rotate: '0deg',
								duration: 0.8,
								ease: CustomEase.create('card-cta', '0.67,0,0.24,1.24'),
							},
							'start'
						);

						tl.to(
							card.querySelector('.card-cta__link-text'),
							{
								translateX: '0',
								duration: 0.8,
								ease: CustomEase.create('card-cta', '0.67,0,0.24,1.24'),
							},
							'start'
						);

						tl.to(
							card,
							{
								height: '410px',
								duration: 0.8,
								ease: CustomEase.create('card-cta', '0.67,0,0.24,1.24'),
							},
							'start'
						);

						tl.to(
							card.querySelector('.card-cta__content'),
							{
								opacity: 1,
								height: 'auto',
								duration: 0.55,
							},
							'start'
						);

						card.addEventListener('mouseenter', () => {
							tl.play();
						});

						card.addEventListener('mouseleave', () => {
							tl.reverse();
						});

						if (card.querySelector('.card-cta__link')) {
							card.querySelector('.card-cta__link').addEventListener('focus', () => {
								tl.play();
							});
							card.querySelector('.card-cta__link').addEventListener('blur', () => {
								tl.reverse();
							});
						}
					});
				}
			);
		}
	});
}
